<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        GENERIC SMS APP
        <small>View All Applications</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">View All Applications</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-lg-10 col-lg-offset-1">
                <h3>Saved Applications</h3>
                <table v-show="savedApps.length" class="table table-striped">
                  <thead>
                    <th>Application Name</th>
                    <th>Last Saved Date</th>
                    <th>Edit</th>
                    <th>Download JSON</th>
                  </thead>
                  <tbody>
                    <tr v-for="(eachApp, index) in savedApps" :key="index">
                      <td>{{eachApp.name}}</td>
                      <td>{{formatDate(eachApp.savedDate)}}</td>
                      <td><router-link class="btn btn-primary" :to="`new?app=${eachApp._id}`">Edit</router-link></td>
                      <td><button class="btn btn-primary" v-on:click="download('savedApps', index)">Download</button></td>
                    </tr>
                  </tbody>
                </table>

                <br /><br />
                <h3>Deployed Applications</h3>
                <table v-show="deployedApps.length" class="table table-striped">
                  <thead>
                    <th>Application Name</th>
                    <th>Last Deployed Date</th>
                    <th>Last Released Date</th>
                    <th>Edit</th>
                    <th>Download JSON</th>
                    <th>Release</th>
                  </thead>
                  <tbody>
                    <tr v-for="(eachApp, index) in deployedApps" :key="index">
                      <td>{{eachApp.name}}</td>
                      <td>{{formatDate(eachApp.deployedDate)}}</td>
                      <td>{{formatDate(eachApp.releasedDate)}}</td>
                      <td><router-link class="btn btn-primary" :to="`new?app=${eachApp._id}`">Edit</router-link></td>
                      <td><button class="btn btn-primary" v-on:click="download('deployedApps', index)">Download</button></td>
                      <td><button class="btn btn-primary" v-on:click="release(index)">Release</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import api from '../../../utils/api'

  export default {
    name: 'view-apps',
    methods: {
      /**
       * @function loadApps
       * @description load all saved/deployed apps
       * @param {Boolean} deployed - flag to check if only deployed apps or saved apps
       */
      loadApps (deployed = false) {
        let url = `${process.env.api_endpoint}/api/app`
        url += deployed ? '?deployed=1' : ''
        api.buildRequest(url, 'GET')
          .then(response => {
            if (response.status === 200) {
              if (deployed) {
                this.deployedApps = response.data.payload.apps
              } else {
                this.savedApps = response.data.payload.apps
              }
            }
          })
      },

      /**
       * @function formatDate
       * @description formats the date coming from mongodb
       * @param {string} date - the date value stored in db
       */
      formatDate (date) {
        if (!date) {
          return ''
        }
        const theDate = new Date(date)
        return `${theDate.getDate()}/${theDate.getMonth() + 1}/${theDate.getFullYear()} ${theDate.getHours()}:${theDate.getMinutes()}`
      },

      /**
       * @function download
       * @description downloads the json file
       * @param {string} type - the type of apps (savedApps or deployedApps)
       * @param {number} index - the array index
       */
      download (type, index) {
        const config = JSON.stringify(this[type][index].config, null, 2)
        const blob = new Blob([config], { type: 'application/json' })
        const url = window.URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = url
        a.download = this[type][index].name
        a.textContent = 'Download'
        var event = document.createEvent('MouseEvents')
        event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null)
        a.dispatchEvent(event)
      },

      /**
       * @function release
       * @description promote the current app to production
       * @param {number} index - the index of the app in the deployedApps array
       */
      release (index) {
        const appId = this.deployedApps[index]._id
        const url = `${process.env.api_endpoint}/api/app/${appId}?name=${this.deployedApps[index].name}`
        api.buildRequest(url, 'PUT', { config: this.deployedApps[index].config })
          .then(response => {
            this.$swal({
              type: response.status === 200 ? 'success' : 'error',
              text: response.data.payload.message
            })
            if (response.status === 200) {
              // this
            }
          }).catch(({ response }) => {
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      }
    },
    data () {
      return {
        savedApps: [],
        deployedApps: []
      }
    },
    mounted () {
      this.loadApps()
      this.loadApps(true)
    }
  }
</script>

<style>
  .value {
    font-weight: bold;
  }
  .box-body {
    min-height: calc(100vh - 171px);
  }
  .form-loader img {
    width: 30px;
    height: 30px;
  }
  .action-button {
    clear: both;
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// view.vue?d47d4bdc